import { makeStyles } from 'tss-react/mui';
import { CHAT_WIDTH } from '../../utils/chat.constants';

interface UseChatMessagesStylesParams {
  isEditingChat: boolean;
}

export const useChatMessagesStyles = makeStyles<UseChatMessagesStylesParams>()(
  (theme, { isEditingChat }) => ({
    root: {
      width: CHAT_WIDTH,

      [theme.breakpoints.down('sm')]: {
        width: '100%',
        height: '100%',
        border: 0,
        borderRadius: 0,
      },
    },
    chatMessageViewWrapper: {
      display: isEditingChat ? 'none' : 'block',
    },
  }),
);
